<ion-header [translucent]="false" class="ion-no-border custom-header" mode="md">
  <ion-toolbar>
    <ion-title class="modal-title">{{'download_pdf' | translate}}</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content [fullscreen]="true" class="ion-padding">
  <div class="configuration-container">
    <ng-container class="contentDiv">
      <div class="form-container">
        <div class="section-title">
          {{ 'results_to_include' | translate }}
        </div>
        <ion-list lines="none">
          <!-- <ion-item>
            <ion-checkbox slot="start">
            </ion-checkbox>
            <ion-label class="checkbox-label">
              {{ 'uw_result' | translate }}
            </ion-label>
          </ion-item> -->
          <ion-item *ngIf="showUWReport">
            <ion-checkbox slot="start" [(ngModel)]="generateUWReport" [disabled]="isLoading">
            </ion-checkbox>
            <ion-label class="checkbox-label">
              {{ 'uw_result' | translate }}
            </ion-label>
          </ion-item>

          <ion-item *ngIf="showComfReport">
            <ion-checkbox slot="start" [(ngModel)]="generateComfortCalculator" [disabled]="isLoading">
            </ion-checkbox>
            <ion-label class="checkbox-label">
              {{ 'comfort_calculator' | translate }}
            </ion-label>
          </ion-item>
          <!-- <ion-item *ngIf="showEnergySavings">
            <ion-checkbox slot="start">
            </ion-checkbox>
            <ion-label class="checkbox-label">
              {{ 'energy_savings' | translate }}
            </ion-label>
          </ion-item> -->

          <ion-item *ngIf="showWERReport">
            <ion-checkbox slot="start" [(ngModel)]="generateWerReport" [disabled]="isLoading">
            </ion-checkbox>
            <ion-label class="checkbox-label">
              {{ 'window_energy_ratings' | translate }}
            </ion-label>
          </ion-item>

          <ion-item *ngIf="showSWSReport">
            <ion-checkbox slot="start" [(ngModel)]="generateSWSReport" [disabled]="isLoading">
            </ion-checkbox>
            <ion-label class="checkbox-label">
              {{ 'sws_air_simulation' | translate }}
            </ion-label>
          </ion-item>
        </ion-list>
      </div>
    </ng-container>
  </div>
</ion-content>
<ion-footer [translucent]="false" class="ion-no-border ">
  <div class="button-container">
    <ion-button fill="outline" class="cancel-btn" (click)="close()" expand="block">
      {{'cancel' | translate}}
    </ion-button>
    <ion-button class="next-btn" (click)="downloadPDF()" expand="block">
      {{'download' | translate}}
    </ion-button>
  </div>
</ion-footer>